import { useState } from "react";
import { CaretDown, CaretUp, CheckCircle } from "@phosphor-icons/react";

const title = (l) => [l.name, l.strength, l.pack].filter(Boolean).join(" · ");
const tone = (v, target) => (v >= target && target > 0 ? "text-emerald-700" : v > 0 ? "text-amber-700" : "text-muted-foreground");

export const FulfilmentPanel = ({ r, number }) => {
  const [open, setOpen] = useState(false);
  if (!r?.lines?.length) return null;
  return (
    <div className="mt-2 rounded-sm border border-border bg-muted/20" data-testid={`fulfilment-panel-${number}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-3 py-1.5 text-xs" data-testid={`fulfilment-toggle-${number}`}>
        <span className="font-semibold uppercase tracking-wide text-muted-foreground">Proforma vs received vs packed</span>
        <span className="flex items-center gap-3 tabular-nums">
          <span>PI <b>{r.ordered}</b></span><span className={tone(r.received, r.ordered)}>Received <b>{r.received}</b></span><span className={tone(r.packed, r.ordered)}>Packed <b>{r.packed}</b></span>
          {open ? <CaretUp size={13} /> : <CaretDown size={13} />}
        </span>
      </button>
      {open && (
        <div className="border-t border-border">
          <div className="grid grid-cols-[1fr_64px_72px_64px_72px] gap-2 px-3 py-1.5 text-[10px] uppercase tracking-wide text-muted-foreground"><span>Item</span><span className="text-right">PI qty</span><span className="text-right">Received</span><span className="text-right">Packed</span><span className="text-right">To pack</span></div>
          {r.lines.map((l, i) => (
            <div key={i} className="grid grid-cols-[1fr_64px_72px_64px_72px] gap-2 px-3 py-1.5 text-xs border-t border-border/60 items-center" data-testid={`fulfilment-line-${number}-${i}`}>
              <span className="truncate flex items-center gap-1">{l.packed >= l.ordered && l.ordered > 0 && <CheckCircle size={12} weight="fill" className="text-emerald-600 shrink-0" />}{title(l)}</span>
              <span className="text-right tabular-nums">{l.ordered}</span>
              <span className={`text-right tabular-nums ${tone(l.received, l.ordered)}`} data-testid={`fulfilment-received-${number}-${i}`}>{l.received}</span>
              <span className={`text-right tabular-nums ${tone(l.packed, l.ordered)}`} data-testid={`fulfilment-packed-${number}-${i}`}>{l.packed}</span>
              <span className={`text-right tabular-nums font-semibold ${l.to_pack > 0 ? "text-amber-700" : "text-muted-foreground"}`} data-testid={`fulfilment-topack-${number}-${i}`}>{l.to_pack}</span>
            </div>
          ))}
          {!r.has_packing_list && <p className="px-3 py-1.5 text-[11px] text-muted-foreground border-t border-border/60">No packing list generated yet — packed quantities come from the proforma packing list.</p>}
        </div>
      )}
    </div>
  );
};
